import  { useState } from 'react';              
import { Typography, IconButton, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

const ExpandableComponent = ({ title, Child }) => {
    const [expanded, setExpanded] = useState(false);

    const handleExpand = () => {
        setExpanded(!expanded);
    };

    return (
        <div style={{display:'flex',flexDirection:'column',background:'white',borderRadius:'4px',boxShadow:'0px 0.4px 1px 1px rgba(0,0,0,0.2)',padding:'10px'}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{display:'flex',flex:1.99,fontSize:16}} variant="h6">{title}</Typography>
                <IconButton sx={{display:'flex',flex:0.01}} onClick={handleExpand} size="small">
                    {expanded?<ExpandLess />:<ExpandMoreIcon />}
                </IconButton>
            </div>
            <Collapse in={expanded} >
                {Child}
            </Collapse>
        </div>
    );
};

export default ExpandableComponent;
